interface GHLRedirect {
    APP_REDIRECT: string;
}

interface GHLCredentials {
    CLIENT_ID: string;
    CLIENT_SECRET: string;
    SCOPE: string;
    REDIRECT: GHLRedirect;
}

interface EnvironmentConfig {
    SERVER: string;
    API_URL: string;
    GHL: GHLCredentials;
}

const env: EnvironmentConfig = {
    SERVER: 'https://datadriverapi.fixmyonline.com',
    API_URL: 'https://datadriverapi.fixmyonline.com',
    // API_URL: 'http://localhost:8082',

    GHL: {
        CLIENT_ID: '686ba3929f5f9c4d05a4bf70-mct0bx98',
        CLIENT_SECRET: 'c0a929ec-6665-44b3-a86f-56bfc329f615',
        SCOPE: 'contacts.readonly contacts.write campaigns.readonly conversations.readonly conversations.write forms.readonly conversations/message.write links.readonly links.write conversations/message.readonly locations.readonly locations/customFields.readonly locations/customFields.write locations/customValues.write locations/customValues.readonly locations/tags.write locations/tags.readonly locations/tasks.write locations/tasks.readonly opportunities.readonly opportunities.write locations/templates.readonly surveys.readonly users.write users.readonly workflows.readonly',
        REDIRECT: {
            APP_REDIRECT: 'http://localhost:3000/integrations/auth/app',
        },
    },
};

export default env;
